import { BooleanCell } from "./BooleanCell";

export const ScoreCell = ({
  isBoolean,
  isNumber,
  booleanValue,
  children,
}: {
  isBoolean: boolean;
  isNumber?: boolean;
  booleanValue: boolean;
  children: React.ReactNode;
}) => {
  if (isBoolean) {
    return <BooleanCell value={booleanValue} />;
  }

  if (isNumber) {
    const numericValue =
      typeof children === "number"
        ? children
        : typeof children === "string" && !isNaN(parseFloat(children))
        ? parseFloat(children)
        : null;

    if (numericValue !== null) {
      const formattedValue = Number.isInteger(numericValue)
        ? numericValue.toString()
        : numericValue.toFixed(2);

      return (
        <div className="flex h-full w-full items-center justify-center font-mono text-base font-medium">
          {formattedValue}
        </div>
      );
    }
  }

  return (
    <div
      className={
        "my-auto flex max-h-[250px] justify-center overflow-y-auto whitespace-pre-wrap px-3 py-1"
      }
    >
      {children}
    </div>
  );
};
